import React from 'react';

import OrderProcessingProgressBar from 'organisms/orderProcessingProgressBar/container/orderProcessingProgressBar';

const OrderProcessingView = props => {
  const { orderDetails } = props;
  const { displayOrderProcessingPage, isMobileView } = orderDetails;

  return (
    <React.Fragment>
      <div className={`orderProcessingPage au col-12 ${isMobileView ? 'mobileView' : ''}`}>
        {displayOrderProcessingPage && <OrderProcessingProgressBar {...props} />}
      </div>
    </React.Fragment>
  );
};

export default React.memo(OrderProcessingView);
